import { DropdownMenu } from '../../ui/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import { DropdownMenuTrigger } from '@radix-ui/react-dropdown-menu';
import DropdownContent from '../dropdown/DropdownContent';


/**
 *
 * @param root0
 * @param root0.trigger
 * @param root0.triggerClass
 * @param root0.tooltipContent
 * @param root0.tooltipContentClass
 * @param root0.actions
 * @param root0.side
 * @param root0.align
 * @param root0.delayDuration
 * @returns {JSX} TooltipAndDropdownHelper
 */
function TooltipAndDropdownHelper({
    trigger,
    triggerClass,
    tooltipContent,
    tooltipContentClass,
    actions,
    side,
    align,
    delayDuration = 300
}) {
    return (
        <DropdownMenu>
            <Tooltip delayDuration={delayDuration}>
                <DropdownMenuTrigger asChild disabled={trigger.props.disabled}>
                    <TooltipTrigger className={triggerClass} asChild >
                        {trigger}
                    </TooltipTrigger>
                </DropdownMenuTrigger>
                <TooltipContent className={tooltipContentClass}>
                    {tooltipContent}
                </TooltipContent>
            </Tooltip>
            <DropdownContent actions={actions} side={side} align={align} hasTooltip={true} />
        </DropdownMenu >
    );
}

export default TooltipAndDropdownHelper;